import React from "react";
import PropTypes from "prop-types";

export default function CardFinanceStats({
  statSubtitle,
  statTitle,
  count,
  statIconName,
  statIconColor,
  onClickFirst,
  tailwindStyles,
}) {
  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words rounded mb-6 xl:mb-0 shadow-lg " +
          tailwindStyles
        }
      >
        <div className="flex-auto p-4">
          <div className="flex">
            <div className="relative w-full pr-4 max-w-full flex-grow flex-1">
              <h5 className="text-blueGray-400 uppercase font-bold text-xs">
                {statSubtitle}
              </h5>
              <div
                className="mt-3 cursor-pointer text-center pt-3"
                onClick={onClickFirst}
              >
                <span className={"text-blue font-[100] text-[1.5rem]"}>
                  {statTitle}
                </span>
              </div>
              {/* <span class="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                12.5%
              </span> */}

              {count ? (
                <div
                  className="cursor-pointer text-center mb-2 "
                  onClick={onClickFirst}
                >
                  <span className={"text-xl text-blueGray-400 font-bold mr-2"}>
                    {count}
                  </span>{" "}
                  Deliverables
                </div>
              ) : null}
            </div>

            <div className="relative w-auto pl-4 flex-initial">
              {statIconName ? (
                <div
                  className={
                    "text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg  rounded-full " +
                    statIconColor
                  }
                >
                  <i className={statIconName}></i>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

CardFinanceStats.defaultProps = {
  statSubtitle: "Traffic",
  statTitle: "0",
  statArrow: "up",
  statPercent: "0",
  statPercentColor: "text-emerald-500",
  statIconName: undefined,
  statIconColor: "bg-red-500",
};

CardFinanceStats.propTypes = {
  statSubtitle: PropTypes.string,
  statArrow: PropTypes.oneOf(["up", "down"]),
  statPercent: PropTypes.string,
  // can be any of the text color utilities
  // from tailwindcss
  statPercentColor: PropTypes.string,
  statDescripiron: PropTypes.string,
  statIconName: PropTypes.string,
  // can be any of the background color utilities
  // from tailwindcss
  statIconColor: PropTypes.string,
};
